import {ActionEvent} from "../../grid/abstract-column.component";

export class SearchActionEvent implements ActionEvent {
    static readonly ACTION_VIEW: string = "VIEW";

    static readonly ACTION_EDIT: string = "EDIT";

    static readonly ACTION_SELECT_SINGLE: string = "SELECT_SINGLE";

    static readonly ACTION_SELECT_RECORDS: string = "SELECT_RECORDS";

    static readonly ACTION_REMOVE: string = "REMOVE";

    /**
     * Indicates that an action has started
     */
    static readonly ACTION_START: string = "START";

    /**
     * Indicates that an action has completed
     */
    static readonly ACTION_END: string = "END";


    /**
     * Add an record from another record
     */
    static readonly ACTION_ADD_FROM_RECORD: string = "ADD_FROM_RECORD";


    action: string;
    item: any;

    constructor(action: string, item: any) {
        this.action = action;
        this.item = item;
    }
}
